import { CheckCircle2, CircleDashed, Loader2, XCircle } from 'lucide-react';
import { Badge } from '../ui/Badge';
import type { FileStatus } from '../../api/types';

const LABELS: Record<FileStatus, string> = {
  INIT: 'Ожидает',
  SELECT_PAGES: 'Выбор страниц',
  IN_PROGRESS: 'Обрабатывается',
  COMPLETED: 'Готово',
  FAILED: 'Ошибка',
};

export function FileStatusBadge({ status }: { status: FileStatus }) {
  switch (status) {
    case 'COMPLETED':
      return (
        <Badge variant="success" icon={<CheckCircle2 size={12} />}>
          {LABELS.COMPLETED}
        </Badge>
      );
    case 'FAILED':
      return (
        <Badge variant="error" icon={<XCircle size={12} />}>
          {LABELS.FAILED}
        </Badge>
      );
    case 'IN_PROGRESS':
      return (
        <Badge
          variant="warning"
          icon={<Loader2 size={12} className="animate-spin" />}
        >
          {LABELS.IN_PROGRESS}
        </Badge>
      );
    case 'SELECT_PAGES':
      return (
        <Badge variant="info" icon={<CircleDashed size={12} />}>
          {LABELS.SELECT_PAGES}
        </Badge>
      );
    default:
      return (
        <Badge variant="default" icon={<CircleDashed size={12} />}>
          {LABELS.INIT}
        </Badge>
      );
  }
}
